<template>
  <div class="share-container" v-if="value" :style="{ zIndex: zIndex }">
    <div
      class="share-overlay"
      v-if="overlay"
      :style="{ zIndex: zIndex }"
      @click.stop="bindClose"
    ></div>
    <div
      class="share-box"
      :style="{ zIndex: zIndex + 2 }"
      @click.stop="bindClose"
    >
      <div
        v-if="posterUrl && showPoster"
        class="poster"
        :style="{ zIndex: zIndex + 1 }"
      >
        <PosterComponent :url="posterUrl" />
      </div>
      <template v-if="!posterUrl"><slot></slot></template>
    </div>
    <div class="share-content" @click.stop :style="{ zIndex: zIndex + 2 }">
      <div class="title">{{ title }}</div>
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div class="list-scroll">
        <div class="list">
          <div
            class="item"
            :class="[item.className]"
            v-for="(item, index) in iconList"
            :key="index"
            @click="bindShareClick(item, index)"
          >
            <div
              class="item-icon"
              :style="{ animationDelay: +duration + 0.1 * index + 's' }"
            >
              <img class="icon-img" :src="item.icon" alt="" />
            </div>
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import PosterComponent from './poster.vue'
import { defultShareIcons, shareCopyBtn } from './share-method.js'
export default {
  components: {
    PosterComponent
  },
  props: {
    position: {
      type: String,
      default: 'top'
    },
    value: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: '去分享'
    },
    duration: {
      type: Number | String,
      default: 0.3
    },
    //是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number | String,
      default: 2000
    },
    posterUrl: {
      type: String,
      default: ''
    },
    qrcodeUrl: {
      type: String,
      default: 'https://member3.gymcity.com.cn/#/app-download'
    },
    poster: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconList() {
      if (this.options && this.options.length) {
        return this.options
      } else {
        return this.defultShareIcons
      }
    }
  },
  data() {
    return {
      defultShareIcons,
      clipboard: null,
      showPoster: false
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.showPoster = this.poster
        this.$nextTick(() => {
          this.bindAddCopy()
        })
      }
    }
  },
  created() {
    this.showPoster = this.poster
  },
  mounted() {},
  methods: {
    //监听复制
    bindAddCopy() {
      let item = this.iconList.find((item) => {
        return item.copy
      })
      if (item) {
        let dom = document.getElementsByClassName(
          item.className || shareCopyBtn
        )[0]
        if (!dom) {
          return
        }
        this.clipboard = new Clipboard(dom, {
          text: () => {
            return this.qrcodeUrl
          }
        })
        this.clipboard.on('success', () => {
          this.$toast('复制链接成功')
        })
        this.clipboard.on('error', () => {
          this.$toast('复制失败')
        })
      }
    },
    bindStop() {},
    //点击分享链接时的按钮
    bindClick(index) {
      this.$emit('link', index)
    },
    //点击分享图片时的按钮
    bindShareClick(item, index) {
      this.showPoster = !!item.showPoster
      console.log(this.showPoster)
      this.$emit('select', item, index)
    },
    bindClose() {
      this.showPoster = false
      this.$emit('input', false)
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.share-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .poster {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .share-box {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
}

.share-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
}

.share-content {
  position: relative;
  width: 100%;
  background: #f9f9f9;
  padding: 17px 20px;
  @include paddingBottom(17px);
  box-sizing: border-box;
  animation: moveup 0.3s ease;

  .title {
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .close {
    position: absolute;
    padding: 10px;
    top: 5px;
    right: 5px;
    color: #000;
    font-size: 14px;
  }

  .list-scroll {
    //max-height: 190px;
    /*  overflow-y: scroll; */
  }

  .list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .item {
      width: 25%;
      margin-bottom: 10px;

      .item-icon {
        margin: 0 auto;
        width: 60px;
        height: 60px;
        background: #ffffff;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        margin-bottom: 10px;
        animation: moveUpDown 0.3s ease-in-out 0.3s;

        .icon-img {
          transform: scale(0.33);
        }
      }

      .item-icon:active {
        transform: scale(0.95);
      }

      .item-name {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
      }
    }
  }
}

@keyframes moveup {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}

@keyframes moveUpDown {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  70% {
    opacity: 1;
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
